import { useSelectBehaviour } from '../select/utils/select.hooks'
import {
  DashSimpleSelect,
  type DashSimpleSelectProps,
} from '../../dash-blocks/dash-simple-select/DashSimpleSelect'

export const SimpleSelect = <TValue extends string | number | null | undefined = string>(
  props: DashSimpleSelectProps<TValue>
) => {
  const behaviour = useSelectBehaviour()

  return <DashSimpleSelect<TValue> {...behaviour} {...props} />
}
